import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

// The product wall, client side: the 3d host boots a different root and the
// main dashboard's chunks (Shell, api/client, every route) never load there —
// and nothing under src/threed/ loads on the main host. Keep both imports
// dynamic; a static import of ./App here would drag the whole dashboard into
// the shared entry chunk.
//
// The bots host (bots.airrand.app) is a third root on the same rule: its app
// lives under src/bots/ and loads there and nowhere else.
const hostname = window.location.hostname;
const isThreeD = hostname === "3d.airrand.app" || hostname.startsWith("3d.");
const isBots = hostname === "bots.airrand.app" || hostname.startsWith("bots.");

// A deploy renames every hashed chunk, and the server answers a name it no
// longer has with the app's HTML. A tab opened before the deploy then fails
// the first route it loads lazily: a design opened from a list that sat open,
// a settings page, a blank screen. Reload once to pick up the new build. The
// timestamp stops a loop when the reload does not cure it, and with no
// storage to keep one there is no reload, for the same reason.
const CHUNK_RELOAD_KEY = "airrand:chunk-reload-at";
window.addEventListener("vite:preloadError", () => {
  try {
    const last = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY)) || 0;
    if (Date.now() - last < 30_000) return;
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  } catch {
    return;
  }
  window.location.reload();
});

const Root = React.lazy(() =>
  isBots ? import("./bots/BotsApp") :
  isThreeD
    ? import("./threed/ThreeDApp")
    : import("./App").then((m) => ({ default: m.App })),
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <React.Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
      <Root />
    </React.Suspense>
  </React.StrictMode>
);
